<template>
  <div class="container-fluid">
    <div v-if="loading" class="z-depth-1 white center-align" style="height: 250px">
      <div class="row" style="padding-top: 100px">
        <div class="preloader-wrapper active">
          <div class="spinner-layer spinner-white-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <span>Loading data...</span>
      </div>
    </div>

    <div v-if="!loading" class="row">
      <div class="col s12">
        <div class="col s12 z-depth-1 white">
          <h5>Alarm settings</h5>

          <table>
            <tr>
              <td>Threshold:</td>
              <td class="centered_header" colspan="2">Low/Min</td>
              <td class="centered_header" colspan="2">High/Max</td>
              <td></td>
            </tr>
            <tr>
              <td>Component</td>
              <td class="centered_header">Alarm</td>
              <td class="centered_header">Warning</td>
              <td class="centered_header">Warning</td>
              <td class="centered_header">Alarm</td>
              <td>Unit</td>
            </tr>

            <tr v-for="(setting, index) in settings" v-bind:key="index">
              <td>{{setting.component}}</td>
              <td><input type="number" v-model="setting.alarmLow" step="0.5" :class="{invalid: fieldsWithErrors.includes(setting.component+'.alarmLow')}"></td>
              <td><input type="number" v-model="setting.warningLow" step="0.5" :class="{invalid: fieldsWithErrors.includes(setting.component+'.warningLow')}"></td>
              <td><input type="number" v-model="setting.warningHigh" step="0.5" :class="{invalid: fieldsWithErrors.includes(setting.component+'.warningHigh')}"></td>
              <td><input type="number" v-model="setting.alarmHigh" step="0.5" :class="{invalid: fieldsWithErrors.includes(setting.component+'.alarmHigh')}"></td>
              <td>{{setting.unit}}</td>
            </tr>

            <tr v-if="validationErrors.length > 0">
              <td colspan="6">
                <div v-for="(error, index) in validationErrors" :key="index" class="error">{{error}}</div>
              </td>
            </tr>
          </table>

          <div class="row" style="margin-right:5px; margin-bottom:5px; margin-top:15px;">
              <a class="waves-effect waves-light btn-small right" @click="saveClicked">Save</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComplexDataApi from '@/services/api/ComplexDataApi'
import SwitchApi from '@/services/api/switch/SwitchApi'

export default {
  props: {
    railObject: Object
  },
  data: function () {
    return {
      settings: [],
      loading: true,
      fieldsWithErrors: [],
      validationErrors: []
    }
  },
  mounted: async function () {
    const sw = await SwitchApi.getSwitch(this.railObject.RailObjectId, undefined)
    if (sw.data && sw.data.SwitchPeriodicObjects) {
      const promises = []
      for (let i = 0; i < sw.data.SwitchPeriodicObjects.length; i++) {
        const id = sw.data.SwitchPeriodicObjects[i].RailObjectId
        const promise = SwitchApi.getSwitch(id, undefined).then(switchObj => {
          const setting = ComplexDataApi.getRailObject(id).then(complexObj => {
            if (switchObj.data && complexObj.data) {
              const setting = {
                railObjectId: switchObj.data.RailObjectId,
                component: switchObj.data.Name,
                alarmLow: complexObj.data.AlertValueLow,
                warningLow: complexObj.data.WarningValueLow,
                warningHigh: complexObj.data.WarningValueHigh,
                alarmHigh: complexObj.data.AlertValueHigh,
                unit: 'ºC'
              }
              return setting
            }
          })
          return setting
        })
        promises.push(promise)
      }
      const settings = await Promise.all(promises)
      this.settings = settings.filter(s => s !== undefined).sort(s => s.component)

      this.loading = false
    }
  },
  methods: {
    validateInput: function () {
      const errors = []
      const fields = []
      const requiredFields = ['alarmLow', 'warningLow', 'warningHigh', 'alarmHigh'] // Order is important!
      for (const setting of this.settings) {
        for (let i = 0; i < requiredFields.length - 1; i++) {
          if (setting[requiredFields[i]]) {
            const field = setting.component + '.' + requiredFields[i]

            // Find next field with a value
            let compareIndex = i + 1
            while (!setting[requiredFields[compareIndex]] && compareIndex < requiredFields.length) {
              compareIndex++
            }

            // Compare current field with next field
            if (setting[requiredFields[compareIndex]] && parseFloat(setting[requiredFields[i]]) >= parseFloat(setting[requiredFields[compareIndex]])) {
              const field2 = setting.component + '.' + requiredFields[compareIndex]
              errors.push(field + ': should be less than \'' + field2 + '\'')
              fields.push(field)
            }
          }
        }
      }
      this.validationErrors = errors
      this.fieldsWithErrors = fields
    },
    saveClicked: async function (e) {
      this.validateInput()
      if (this.validationErrors.length > 0) {
        return
      }

      try {
        for (const s of this.settings) {
          s.alarmLow = (s.alarmLow !== '') ? s.alarmLow : null
          s.alarmHigh = (s.alarmHigh !== '') ? s.alarmHigh : null
          s.warningLow = (s.warningLow !== '') ? s.warningLow : null
          s.warningHigh = (s.warningHigh !== '') ? s.warningHigh : null
          await ComplexDataApi.updateRailObject(s.railObjectId, s.alarmLow, s.alarmHigh, s.warningLow, s.warningHigh)
        }
        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'alarm settings saved',
          duration: 1000,
          speed: 1000
        })
      } catch (e) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'alarm settings saved',
          text: '' + e,
          duration: 1000,
          speed: 1000
        })
      }
    }
  }
}
</script>

<style scoped>
.occupied-spacing-right {
  margin-right: 12px
}
.centered_header{
  text-align: center;
}
.error {
  color: red
}
</style>



// WEBPACK FOOTER //
// src/pages/mixedSignals/_alarmSettings.vue